import React, { Component } from "react";
import ListingPage from "../Controls/ListingPage";
import Window from "../Controls/Window";
import AddEditCustomRoles from "../../Settings/AddEditCustomRoles";

class CustomRoleList extends Component {

  constructor(props) {

    super(props);

    this.state = {

      list: [],
      totalCount: 0,
      loading: false,
      page: 1,
      pageSize: 25,

      showDelete: false,
      showAddCustomRole: false,
      selectedRow: null,

      listPageSettings: {

        Title: "Custom Roles",

        Search: {
          showSearch: false,
        },

        HeaderButtons: [
          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          }
        ],

     Columns: [
          { Name: "Role", Type: "field", Columns: [{ Column: "Role" }] },
          {
            Name: "Role",
            Type: "field",
            ShowInMobile: true,
            Columns: [{ Column: "Role" }],
          },
        ],

        RowButtons: [
          {
            ButtonType: "ImageButton",
            Type: "edit",
            Text: "Edit",
            Icon: "edit"
          },
{
  ButtonType: "ImageButton",
  Type: "delete",
  Text: "Delete",
  Icon: "delete",
  condition: (row) => {
    console.log("role", this.props.user.user,"row",row);

 
    return (
      this.props.user.user.hasOwnProperty("Role") &&
      row.hasOwnProperty("Role") &&
      this.props.user.user.Role !== row.Role
    );
  }
}
        ]
      }
    };
  }

  componentDidMount() {
    this.loadData();
  }

  // =====================
  // LOAD DATA
  // =====================

  loadData = async () => {

    this.setState({ loading: true });

    try {

      let customRoles = await this.props.getCustomRoles(
        this.props.user.user.RegistrationID
      );

      customRoles = customRoles || [];

      this.setState({
        list: customRoles,
        totalCount: customRoles.length,
        loading: false,
        page: 1
      });

    } catch (error) {

      console.error(error);

      this.setState({ loading: false });

      this.props.getToastr("Failed to fetch custom role");

    }
  };

  // =====================
  // PAGINATION
  // =====================

  onNextClick = () => {

    const totalPages =
      Math.ceil(this.state.totalCount / this.state.pageSize) || 1;

    if (this.state.page < totalPages) {

      this.setState({
        page: this.state.page + 1
      });

    }

  };

  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState({
        page: this.state.page - 1
      });

    }

  };

  onFirstClick = () => {

    this.setState({
      page: 1
    });

  };

  onLastClick = () => {

    const totalPages =
      Math.ceil(this.state.totalCount / this.state.pageSize) || 1;

    this.setState({
      page: totalPages
    });

  };

  onRecordsPerPageCountChange = (size) => {

    this.setState({
      pageSize: Number(size),
      page: 1
    });

  };

  // =====================
  // HEADER BUTTON
  // =====================

  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "new") {

      this.setState({
        showAddCustomRole: true,
        selectedRow: null
      });

    }

  };

  // =====================
  // ROW BUTTON
  // =====================

  onRowButtonClicked = (btn, row) => {

    if (btn.Type === "edit") {

      this.setState({
        showAddCustomRole: true,
        selectedRow: row
      });

    }

    if (btn.Type === "delete") {

      this.setState({
        showDelete: true,
        selectedRow: row
      });

    }

  };

  // =====================
  // DELETE
  // =====================

  deleteRecord = async () => {

    try {

      this.setState({
        loading: true,
        showDelete: false
      });

      await this.props.deleteCustomRoles(
        this.state.selectedRow.key
      );

      this.props.getToastr(
        "Custom role deleted successfully"
      );

      this.setState({
        selectedRow: null,
        loading: false
      });

      this.loadData();

    } catch (error) {

      console.error(error);

      this.setState({
        loading: false,
        selectedRow: null
      });

      this.props.getToastr(
        "Failed to delete custom role"
      );

    }

  };

  // =====================
  // POPUP
  // =====================

  onClosePopup = () => {

    this.setState({
      showAddCustomRole: false,
      selectedRow: null
    });

  };

  onPostPopupSave = () => {

    this.setState({
      showAddCustomRole: false,
      selectedRow: null
    });

    this.loadData();

  };

  // =====================
  // PAGINATED DATA
  // =====================

  getPagedList = () => {

    const start =
      (this.state.page - 1) * this.state.pageSize;

    const end =
      start + this.state.pageSize;

    return this.state.list.slice(start, end);

  };

  // =====================
  // RENDER
  // =====================
  onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};

  render() {

    return (

      <>

        <ListingPage

          {...this.props}

          listPageSettings={{
            ...this.state.listPageSettings
          }}

           onPageChange={this.onPageChange}
          list={this.getPagedList()}

          loading={this.state.loading}

          totalItemsCount={this.state.totalCount}

          recordFrom={
            (this.state.page - 1)
            * this.state.pageSize
          }

          itemsCountPerPage={
            this.state.pageSize
          }

          onNextClick={this.onNextClick}

          onPreviousClick={
            this.onPreviousClick
          }

          onFirstClick={this.onFirstClick}

          onLastClick={this.onLastClick}

          onRecordsPerPageCountChange={
            this.onRecordsPerPageCountChange
          }

          onHeaderButtonClicked={
            this.onHeaderButtonClicked
          }

          onRowButtonClicked={
            this.onRowButtonClicked
          }

        />

        {/* DELETE */}

        {this.state.showDelete && (

          <Window

            header="Delete"

            modal

            onClose={() =>
              this.setState({
                showDelete: false
              })
            }

            onButtonClick={(btn) => {

              if (btn === "Yes")
                this.deleteRecord();

              else
                this.setState({
                  showDelete: false
                });

            }}

            buttons={[
              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              }
            ]}

          >

            Are you sure you want to delete?

          </Window>

        )}

        {/* ADD / EDIT */}

        {this.state.showAddCustomRole && (

          <AddEditCustomRoles
            {...this.props}
            customRole={this.state.selectedRow}
            onSave={() => this.onPostPopupSave()}
            onClose={() => this.onClosePopup()}
          />

        )}

      </>

    );

  }

}

export default CustomRoleList;